import { copyText } from 'src/constants/copy/copy.utils';

/**
 * User-facing copy for chart titles, labels, and export headers.
 * `id` values mirror keys in `src/translations/en.js` for future i18n.
 */

/** @type {import('./copy.utils').CopyEntry} */
const TOTAL_TSP_CALLS_TITLE = {
    defaultMessage: 'Average TSP Calls Per Hour',
    id: 'DASHBOARD.CHART.TOTAL_TSP_CALLS_PER_HOUR.TITLE',
};

/** @type {import('./copy.utils').CopyEntry} */
const TOTAL_TSP_CALLS_CSV_Y = {
    defaultMessage: 'Average TSP Calls per Hour',
    id: 'DASHBOARD.CHART.TOTAL_TSP_CALLS_PER_HOUR.CSV_Y',
};

/** @type {import('./copy.utils').CopyEntry} */
const TOTAL_TSP_CALLS_CSV_HOUR = {
    defaultMessage: 'Hour',
    id: 'DASHBOARD.CHART.TOTAL_TSP_CALLS_PER_HOUR.CSV_HOUR',
};

export const CHART_COPY = {
    TotalTSPCalls: {
        title: TOTAL_TSP_CALLS_TITLE,
        descriptionKey: 'DASHBOARD.TOTAL_TSP_CALLS_PER_HOUR',
        csvColumnY: TOTAL_TSP_CALLS_CSV_Y,
        csvColumnHour: TOTAL_TSP_CALLS_CSV_HOUR,
    },
};

export const getTotalTSPCallsTitle = () => copyText(CHART_COPY.TotalTSPCalls.title);

export const getTotalTSPCallsCsvColumnY = () => copyText(CHART_COPY.TotalTSPCalls.csvColumnY);

export const getTotalTSPCallsCsvColumnHour = () => copyText(CHART_COPY.TotalTSPCalls.csvColumnHour);
